import { ENVIRONMENT } from "src/environments/environment";

const api = ENVIRONMENT.API;

export const ROUTES_CONFIG = {
  loginUrl: `${api}/security/login`,
  reloginUrl: `${api}/security/relogin`,
  loginJwtUrl: `${api}/security/loginwithjwt`,
  checkotpURL: `${api}/security/checkotp`,
  lock: `${api}/security/locksession`,
  contentUrl: `${api}/content`,
  joinUrl: `${api}/join`,
  logoffUrl: `${api}/security/logoff`,
  changeRoleUrl: `${api}/security/changeRole`,
  changeWorkspaceUrl: `${api}/security/changeWorkspace`,
  checkSessionUrl: `${api}/security/checkSession`,
  metadataurl: `${api}/metadata`,
  unsecureurl: `${api}/unsecure`,
  createsamlrequesturl: `${api}/createsamlrequest`,
  menuurl: `${api}/menu`,
  bookmarksurl: `${api}/bookmarks`,
  forgotpasswordurl: `${api}/forgotpassword`,
  resetpasswordurl: `${api}/resetpassword`,
  loginemailurl: `${api}/requestloginwithemailrequest`,
  loginemailotpurl: `${api}/requestloginwithemailotprequest`,
  approvelocationurl: `${api}/approvelocation`,
  approveemailurl: `${api}/approveemail`,
  actionurl: `${api}/action`,
  unsecureactionurl: `${api}/unsecure/action`,
  dynactionUrl: `${api}`,
  changePasswordURL: `${api}/security/changepassword`,
  conferenceUsers: `${api}/conference/getconferenceusers`,
  conferenceRooms: `${api}/conference/myrooms`,
  conferenceHistory: `${api}/conference/roomhistory`,
  scheduleUrl: `${api}/schedules`,
  unsecureContenturl: `${api}`,
  fun: {
    getFarmerAttachment: `${api}/fun/getfarmerattachment`,
    getDashboardData: `${api}/fun/getdashboarddata`,
  },
  getImageURL: `${api}/content/getimage`,
};
